import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../../hooks/useFetch";

const activityOptions = [
  { emoji: "🎓", label: "Learning" },
  { emoji: "💼", label: "Career" },
  { emoji: "⏱️", label: "Discipline" },
  { emoji: "💪", label: "Health" },
  { emoji: "⚽", label: "Sports" },
  { emoji: "🧱", label: "Build" },
  { emoji: "📈", label: "Productivity" },
  { emoji: "🎯", label: "Focus" },
  { emoji: "📈", label: "Growth" },
  { emoji: "🧿", label: "Attention" },
  { emoji: "❤️", label: "Connection" },
  { emoji: "😊", label: "Emotional Regulation" },
  { emoji: "📋", label: "Routine" },
  { emoji: "🏃", label: "Movement" },
  { emoji: "😴", label: "Sleep" },
  { emoji: "🌟", label: "Confidence" },
  { emoji: "🎬", label: "Entertainment" },
  { emoji: "🧘", label: "Mindfulness" },
  { emoji: "🎨", label: "Creativity" },
  { emoji: "🤝", label: "Relationships" },
  { emoji: "🚀", label: "Entrepreneurship" },
  { emoji: "💰", label: "Financial" },
  { emoji: "👑", label: "Leadership" },
  { emoji: "🤰", label: "MaternityCare" },       // AnvayaEhsaas
  { emoji: "🌱", label: "ChildGrowth" },         // AnvayaGrowth
  { emoji: "🩸", label: "BalanceDiabetes" },     // Balance
  { emoji: "❤️‍🔥", label: "VitalCardio" },       // Vital
  { emoji: "🌸", label: "HerLifeW30+" },         // HerLife
  { emoji: "🫁", label: "Breathe" },             // Breathe
  { emoji: "🌿", label: "Sahara60+" },           // Sahara
  { emoji: "🫘", label: "RenaLife" },            // Renalife
  { emoji: "🧠", label: "NeuroLife" },           // Neurolife
  { emoji: "💓", label: "RhythmThyro" },         // Rythm
  { emoji: "🌈", label: "ThriveGeneral" },       // Thrive
  { emoji: "✨", label: "VibeYouthHealth" },     // Vibe
  { emoji: "🕊️", label: "Udaan518Health" },      // Udaan
  { emoji: "🎗️", label: "HopeLifeOnco" },        // Hopelife
  { emoji: "🦶", label: "PodiaFootHealth" },     // Podialife
];

export default function ScorePlusSubscriptionActivity() {
  // console.log("ScorePlusSubscriptionActivity");
  const authState = useSelector((s) => s.authReducer);
  const [fetchData] = useFetch();

  const userId = authState?.user?._id;
  const userCode = authState?.user?.think5whyscode;
  const userName = authState?.user?.name;
  const token = authState?.token;
  const [subscriptions, setSubscriptions] = useState([]);
  // const [activeSubscription, setActiveSubscription] = useState(null);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState("");
  const [loadingSubs, setLoadingSubs] = useState(true);
  const [activity, setActivity] = useState("");
  const [rows, setRows] = useState([]);

  const fetchMySubs = async () => {
    try {
      const config = {
        url: "/pd/subscription/my/light",
        method: "post",
        data: { userId, product: "ScorePlus" },
        headers: { Authorization: authState.token },
      };
      const response = await fetchData(config, { silent: true });

      if (response?.status) {
        const subs = response.data || [];
        setSubscriptions(subs);

        // if (subs.length > 0) {
        //   setActiveSubscription(subs[0]);
        // }
      }
    } catch (error) {
      console.error("Fetch Subscription Error:", error);
    } finally {
      setLoadingSubs(false);
    }
  };

  useEffect(() => {
    if (userId) fetchMySubs();
  }, [userId]);

  const loadActivities = async () => {
    if (!selectedSubscriptionId) {
        setRows([]);
        return;
    }

    const response = await fetchData(
        {
            url: "/scoreplus/subscription/activity/my",
            method: "post",
            headers: { Authorization: token },
            data: {
                subscriptionId: selectedSubscriptionId,
            },
        },
        { silent: true }
    );

    if (response?.status) {
        setRows(response.data || []);
    }
};

  useEffect(() => {
    loadActivities();
  }, [selectedSubscriptionId]);

  const save = async () => {
    if (subscriptions.length === 0 || !activity || !selectedSubscriptionId) {
        return;
    }

    const option = activityOptions.find((x) => x.label === activity);

    const response = await fetchData({
      url: "/scoreplus/subscription/activity/save",
      method: "post",
      headers: { Authorization: token },
      data: {
        userId: userId,
        subscriptionId: selectedSubscriptionId,
        activityKey: option.label,
        activityLabel: `${option.emoji} ${option.label}`,
      },
    });

    if (response?.status) {
      setActivity("");
      loadActivities();
    }
  };

  const remove = async (id) => {
    const response = await fetchData({
      url: "/scoreplus/subscription/activity/delete",
      method: "post",
      headers: { Authorization: token },
      data: { id },
    });

    if (response?.status) loadActivities();
  };

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-xl p-4">
      <div className="text-white font-bold mb-4">🎯 Subscription Activity</div>
      {subscriptions.length === 0 && (
        <div className="mb-4 rounded-lg border border-amber-600/40 bg-amber-500/10 p-4">
          <div className="text-amber-300 font-semibold">
            ⚠️ No Active ScorePlus Subscription
          </div>

          <div className="text-sm text-gray-300 mt-1">
            You don't have an active ScorePlus subscription yet. Purchase a
            subscription first to map an activity.
          </div>
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-3">
        <div className="grid md:grid-cols-3 gap-3">
          <div>
            <label className="block text-xs text-gray-400 mb-1">Activity</label>

            <select
              disabled={subscriptions.length === 0}
              value={activity}
              onChange={(e) => {
                setActivity(e.target.value);
                setSelectedSubscriptionId("");
              }}
              className="w-full bg-gray-800 rounded px-2 py-2 text-white"
            >
              <option value="">Select Activity</option>

              {activityOptions.map((item) => (
                <option key={item.label} value={item.label}>
                  {item.emoji} {item.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-xs text-gray-400 mb-1">
              Subscription
            </label>

            <select
              value={selectedSubscriptionId}
              onChange={(e) => setSelectedSubscriptionId(e.target.value)}
              disabled={!activity}
              className="w-full bg-gray-800 rounded px-2 py-2 text-white disabled:opacity-50"
            >
              <option value="">Select Subscription</option>

              {subscriptions.map((sub) => (
                <option key={sub._id} value={sub._id}>
                  {new Date(sub.startDate).toLocaleDateString()} →{" "}
                  {new Date(sub.endDate).toLocaleDateString()}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-end">
            <button
              disabled={subscriptions.length === 0 || !activity || !selectedSubscriptionId}
              onClick={save}
              className="bg-cyan-600 hover:bg-cyan-700 disabled:opacity-50 text-white rounded-lg px-4 py-2"
            >
              Save Mapping
            </button>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="text-gray-400 text-xs mb-2">Current Activities</div>

        <div className="flex flex-wrap gap-2">
          {rows.map((item) => (
            <div
              key={item._id}
              className="flex items-center gap-2 bg-gray-800 px-3 py-2 rounded-full text-white"
            >
              <span>{item.activityLabel}</span>

              <button
                onClick={() => remove(item._id)}
                className="text-red-400 hover:text-red-300"
              >
                ✕
              </button>
            </div>
          ))}

          {!rows.length && (
            <div className="text-gray-500 text-sm">No activity mapped.</div>
          )}
        </div>
      </div>
    </div>
  );
}
